import { Component,Input } from '@angular/core';
import {Events,ModalController } from 'ionic-angular';
/**
 * Generated class for the HelpComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'help',
  templateUrl: 'help.html'
})
export class HelpComponent {
  
  @Input() sid: any;
  sections:Array<any>;
  screenFbId:string;
  status: boolean = false;
  constructor(private events:Events,public modalCtrl: ModalController) {
    //this.text = 'Hello World';

  }

  ngOnInit(){

  	this.events.subscribe('help:sections', (screenId, screenFbId, status,sections) => {
       	if(this.sid == screenId){
       		if(status){
       			this.status = true;
       		};
       		if(sections){
       			this.sections = sections;
       		}
           if(screenFbId){
             this.screenFbId = screenFbId;
           }
       	}

    });

  	this.events.publish('help:getSections',this.sid);
  
  }

  ngOnDestroy(){
  	this.events.unsubscribe('help:sections');
  }

  openHelpPopup(){
    if(this.sections && this.sections.length > 0){
       const modal = this.modalCtrl.create('HelpMobalPage',{sections:this.sections,screenFbId:this.screenFbId}, { cssClass: "popup-modal" } );
       modal.present();
    }
   
  
 }

}



// WEBPACK FOOTER //
// ./src/components/help/help.ts